export default "/images/download-cloud.svg?2817d948d07a18805ceb6c7f234ab533";